import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { RxInputInternationalPhoneComponent } from './rx-input-intl-phone.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    IMaskModule,
    RxIconModule,
    RxInputInternationalPhoneComponent,
  ],
  exports: [RxInputInternationalPhoneComponent],
})
export class RxInputInternationalPhoneModule {}
